import React from 'react';

const API_BASE = process.env.REACT_APP_API_URL?.replace('/api', '') || 'http://localhost:5000';

// Change 5: online=green, offline=RED
export default function Avatar({ user, size = 'sm', showStatus = false, isOnline = false }) {
  const sizeClass = `avatar-${size}`;
  const initials = user?.name
    ? user.name.split(' ').map(n => n[0]).slice(0, 2).join('').toUpperCase()
    : '?';
  const avatarUrl = user?.avatar
    ? (user.avatar.startsWith('http') ? user.avatar : `${API_BASE}${user.avatar}`)
    : null;
  const colors = ['#5865f2','#0891b2','#059669','#d97706','#7c3aed','#db2777','#0284c7'];
  const colorIdx = user?.name ? user.name.charCodeAt(0) % colors.length : 0;

  return (
    <div className={`avatar ${sizeClass}`}>
      {avatarUrl
        ? <img src={avatarUrl} alt={user?.name || 'User'} />
        : <div className="avatar-initials" style={{ background: colors[colorIdx] }}>{initials}</div>
      }
      {showStatus && (
        <span className={`status-dot ${isOnline ? 'online' : 'offline'}`} />
      )}
    </div>
  );
}
